import {
  FETCH_BOOKS,
  FETCH_BOOK_DETAILS,
  UPDATE_BOOK_DETAILS,
} from './actionTypes';
import parseError from 'utils/parseError';
import { mapKeys } from 'lodash';

const INITIAL_STATE = {
  data: {},
  meta: {},
  fetching: false,
  editing: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BOOKS.pending:
    case FETCH_BOOK_DETAILS.pending:
      return {
        ...state,
        fetching: true,
        error: null,
      };

    case FETCH_BOOKS.rejected:
    case FETCH_BOOK_DETAILS.rejected:
      return {
        ...state,
        fetching: false,
        error: parseError(action.payload),
      };

    case FETCH_BOOKS.fulfilled:
      return {
        ...state,
        fetching: false,
        data: mapKeys(action.payload.data.data, 'id'),
        meta: action.payload.data.meta,
      };

    case FETCH_BOOK_DETAILS.fulfilled:
      return {
        ...state,
        fetching: false,
        data: {
          ...state.data,
          [action.payload.data.id]: action.payload.data,
        },
      };

    case UPDATE_BOOK_DETAILS.pending:
      return {
        ...state,
        editing: true,
      };

    case UPDATE_BOOK_DETAILS.rejected:
      return {
        ...state,
        editing: false,
      };

    case UPDATE_BOOK_DETAILS.fulfilled:
      return {
        ...state,
        editing: false,
      };

    default:
      return state;
  }
};
